export const PHONE_MASK = (rawValue: string) => {
  const base = [
    '(',
    /[1-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];
  if (rawValue.startsWith('+1')) {
    base.unshift(/\+/, /\d/, ' ');
  } else if (rawValue.startsWith('+')) {
    base.unshift(/\+/, /\d/);
  }
  if (rawValue.startsWith('1')) {
    base.unshift(/\d/, ' ');
  }
  return base;
};
